import type { GalleryProps } from "./gallery.type";

import { useState } from "react";

import { MasonryGrid } from "@/ui/masonry-grid";

import { GalleryModal } from "./gallery-modal";
import { GalleryThumbnail } from "./gallery-thumbnail";

export const Gallery = <Data = unknown,>({
  items,
  extraActions,
  renderExtraActions,
  breakpointCols,
}: GalleryProps<Data>) => {
  const [currentIndex, setCurrentIndex] = useState<number | null>(null);

  return (
    <>
      <MasonryGrid
        breakpointCols={breakpointCols ?? 1}
        items={items.map((item, index) => ({
          key: item.key ?? item.title,
          node: (
            <GalleryThumbnail
              item={item}
              onPreviewClick={() => setCurrentIndex(index)}
              extraActions={extraActions}
              renderExtraActions={renderExtraActions}
            />
          ),
        }))}
      />
      {typeof currentIndex === "number" && (
        <GalleryModal
          items={items}
          defaultOpen
          defaultCurrentSlide={currentIndex}
          onClose={() => setCurrentIndex(null)}
        />
      )}
    </>
  );
};
